import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusToastType } from "./types";
import { TOAST_EXPIRATION, TOAST_SHOW_DURATION } from "../../common/constants";

interface StatusToastState {
  value: StatusToastType[];
}

const initialState: StatusToastState = {
  value: [],
};

export const statusToastSlice = createSlice({
  name: "statusToasts",
  initialState,
  reducers: {
    addStatusToast: (state, action: PayloadAction<StatusToastType>) => {
      // Add timestamp now to toast
      action.payload.Timestamp = Date.now();

      // Contain only toasts in state that are inside time threshold
      const timestampThreshold = action.payload.Timestamp - TOAST_EXPIRATION;
      const filteredToasts = state.value.filter(
        (obj) => obj.Timestamp > timestampThreshold,
      );
      // console.log(filteredToasts);
      filteredToasts.push(action.payload);
      state.value = filteredToasts;
    },
    clearStatusToasts: (state) => {
      state.value = [];
    },
  },
});

export const { addStatusToast, clearStatusToasts } = statusToastSlice.actions;
/*
export const selectStatusToasts = (state) => {
  const timestampThreshold = Date.now() - TOAST_EXPIRATION;
  const filteredToasts = state.statusToast.value.filter(
    (obj) => obj.Timestamp > timestampThreshold,
  );
  return filteredToasts;
};

 */
export const selectStatusToasts = (state) => {
  return state.statusToast.value;
};
export default statusToastSlice.reducer;
